import { render, staticRenderFns } from "./RemoteConfigurator.vue?vue&type=template&id=63ebaae6&"
import script from "./RemoteConfigurator.vue?vue&type=script&lang=js&"
export * from "./RemoteConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports